import ExecAPI from 'appRoot/api/api';

export function GetUserData()
{
	return ExecAPI("UserData/GetUserData");
}
export function SetUserData(userData)
{
	return ExecAPI("UserData/SetUserData", { userData });
}
export function AddUser(userData)
{
	return ExecAPI("UserData/AddUser", { userData });
}
export function RemoveUser(userId)
{
	return ExecAPI("UserData/RemoveUser", { userId });
}